import { STAGE_COLORS } from '../utils/constants';

export function StageBadge({ stage }) {
  const colors = STAGE_COLORS[stage] || STAGE_COLORS.NONE;
  return (
    <span
      data-testid={`stage-badge-${(stage || 'none').toLowerCase()}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[11px] font-mono font-medium border ${colors.bg} ${colors.text} ${colors.border}`}
    >
      {stage || 'NONE'}
    </span>
  );
}

export function ExitBadge({ exitMode }) {
  if (!exitMode || exitMode === 'NONE') return null;
  const colors = {
    CONFIRMED: 'bg-trading-red/15 text-trading-red border-trading-red/30',
    WARNING: 'bg-trading-amber/15 text-trading-amber border-trading-amber/30',
    FORCED_EXIT: 'bg-trading-red/20 text-trading-red border-trading-red/40',
  };
  return (
    <span
      data-testid={`exit-badge-${exitMode.toLowerCase()}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[11px] font-mono font-medium border ${colors[exitMode] || ''}`}
    >
      {exitMode === 'FORCED_EXIT' ? 'FORCED' : exitMode}
    </span>
  );
}

export function AlignmentBadge({ alignment }) {
  const colors = {
    ALIGN: 'text-trading-green',
    DIVERGE: 'text-trading-amber',
    CONFLICT: 'text-trading-red',
  };
  return (
    <span
      data-testid={`alignment-badge-${(alignment || 'align').toLowerCase()}`}
      className={`font-mono text-[11px] font-medium ${colors[alignment] || 'text-trading-muted'}`}
    >
      {alignment || 'ALIGN'}
    </span>
  );
}

export function ScoreBadge({ score, label }) {
  const getColor = (s) => {
    if (s >= 8.5) return 'text-trading-green';
    if (s >= 7.5) return 'text-trading-blue';
    if (s >= 6.0) return 'text-trading-amber';
    if (s >= 5.0) return 'text-trading-muted';
    return 'text-trading-muted/60';
  };
  return (
    <span className={`font-mono text-sm tabular-nums ${getColor(score)}`}>
      {label && <span className="text-[10px] text-trading-muted mr-1">{label}</span>}
      {(score || 0).toFixed(1)}
    </span>
  );
}
